import { render, staticRenderFns } from "./aiChart.vue?vue&type=template&id=124fcee9&scoped=true"
import script from "./aiChart.vue?vue&type=script&lang=js"
export * from "./aiChart.vue?vue&type=script&lang=js"
import style0 from "./aiChart.vue?vue&type=style&index=0&id=124fcee9&prod&lang=less&scoped=true"
import style1 from "./aiChart.vue?vue&type=style&index=1&id=124fcee9&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124fcee9",
  null
  
)

export default component.exports